import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-4xl">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms and Conditions</h1>
      <p className="text-gray-500 text-sm mb-8">Last updated: June 2025</p>

      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 space-y-8 text-gray-700 text-sm leading-relaxed">

        <section>
          <p className="text-base">
            Welcome to <strong>KLMKart (PK Agri)</strong>. By accessing or purchasing from this website (
            <a href="https://klmkart.com" className="text-blue-600 hover:underline">klmkart.com</a>
            ), you agree to be bound by the following Terms and Conditions. Please read them carefully before
            making any purchase or using our services.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">1. Product Availability</h2>
          <p>
            All products listed on our website are subject to availability. We reserve the right to limit the
            quantity of any product or discontinue any product at any time without prior notice. In the event
            a product is unavailable after an order has been placed, we will notify you and process a full
            refund for the unavailable item.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">2. Pricing</h2>
          <p>
            All prices listed on this website are in Indian Rupees (INR) and are inclusive of applicable GST
            unless stated otherwise. Prices are subject to change without prior notice. The price at the time
            of placing your order will be the final price charged to you for that transaction.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">3. Order Processing & Payment</h2>
          <p>
            Orders will be processed only after successful payment confirmation. We accept payments via UPI,
            debit/credit cards, net banking, and other methods available through our payment gateway. All
            payment transactions are secured and processed by our authorized payment partners. KLMKART does
            not store your card or payment details.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">4. Delivery & Shipping</h2>
          <p>
            Delivery timelines provided at checkout are estimates and may vary due to logistics conditions,
            courier delays, weather, public holidays, or other unforeseen circumstances. The company is not
            responsible for courier delays or circumstances beyond our control.
            <Link to="/shipping-policy" className="text-blue-600 hover:underline">Shipping Policy</Link>.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">5. Returns & Refunds</h2>
          <p>
            Returns are accepted only for damaged or defective products reported within <strong>3 days</strong> of
            delivery. To initiate a return, please contact our support team with photographic evidence of the
            damage or defect. Products must be returned in original packaging. Refunds will be processed to the
            original payment method within 7–10 business days after the return is received and verified. For
            complete details, refer to our{' '}
            <Link to="/refund-policy" className="text-blue-600 hover:underline">Refund & Cancellation Policy</Link>.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">6. Product Images & Descriptions</h2>
          <p>
            Product images displayed on this website are for reference purposes only. Actual products may
            slightly vary in colour, appearance, or packaging due to photographic lighting, screen display
            settings, or manufacturer updates. We strive to provide accurate descriptions but do not warrant
            that product descriptions are error-free.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">7. Intellectual Property</h2>
          <p>
            All website content, including but not limited to text, images, logos, graphics, product
            descriptions, and page designs, is the exclusive property of KLMKart (PK Agri) and is protected
            under applicable Indian intellectual property laws. Unauthorized copying, reproduction,
            redistribution, or commercial use of any content is strictly prohibited.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">8. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, KLMKart shall not be liable for any indirect, incidental,
            special, or consequential damages arising from the use of our website or purchase of products. Our
            maximum liability shall not exceed the amount paid by the customer for the specific product or
            service in question.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">9. Privacy</h2>
          <p>
            Your personal data is collected and used in accordance with our{' '}
            <Link to="/privacy-policy" className="text-blue-600 hover:underline">Privacy Policy</Link>. By
            using this website, you consent to the collection and use of your information as described therein.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">10. Governing Law</h2>
          <p>
            These Terms and Conditions shall be governed by and construed in accordance with the laws of India.
            Any disputes arising from or related to these Terms shall be subject to the exclusive jurisdiction
            of the courts located in Telangana, India.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">11. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms and Conditions at any time. Changes will be effective
            immediately upon posting to the website. Your continued use of the website after any changes
            constitutes your acceptance of the new Terms.
          </p>
        </section>

        <section className="border-t border-gray-100 pt-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-3">Contact Information</h2>
          <p className="mb-4">If you have any questions about these Terms and Conditions, please contact us:</p>
          <div className="bg-gray-50 rounded-lg p-4 space-y-2">
            <p><strong>Company Name:</strong> KLMKart </p>
            <p><strong>Website:</strong> <a href="https://klmkart.com" className="text-blue-600 hover:underline">klmkart.com</a></p>
            <p><strong>Email:</strong> <a href="mailto:klmkartsales@gmail.com" className="text-blue-600 hover:underline">klmkartsales@gmail.com</a></p>
            <p><strong>Phone:</strong> <a href="tel:+917995004136 " className="text-blue-600 hover:underline">+91 7995004136 </a></p>
            <p><strong>Address:</strong> H.NO-8-5-136/12/P,T, S.R. COMPLEX, DURGA NAGAR X ROAD, MAILARDEVPALLY, RAJENDRANAGAR, Rangareddy</p>
          </div>
        </section>

      </div>
    </div>
  );
};

export default TermsOfService;